import { render, staticRenderFns } from "./report-grow-form.vue?vue&type=template&id=af2225ec&scoped=true"
import script from "./report-grow-form.vue?vue&type=script&lang=ts"
export * from "./report-grow-form.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af2225ec",
  null
  
)

export default component.exports